import React from "react";
import { Stack } from "@mui/material";
import { Controller } from "react-hook-form";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Form } from "react-bootstrap";

const SwitchField = ({
  name,
  control,
  label,
  onChangeCallback = () => {},
  disabled = false,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          onClick={() => onChangeCallback()}
        >
          <BootstrapSwitchButton
            onChange={(e) => {
              onChange(e);
            }}
            onBlur={onBlur}
            checked={!!value}
            disabled={disabled}
            size="sm"
            onlabel="Yes"
            offlabel="No"
            onstyle="success"
            inputRef={ref}
            {...props}
          />
          <Form.Label>{label}</Form.Label>
        </Stack>
      )}
    />
  );
};

export default SwitchField;
